/**
 * Credit action costs — frontend mirror of `api.salesommo.com/config/credits.php`
 * (`action_costs`). Used by the run-now confirm modal and the unlock-email modal.
 *
 * NOTE: There is no `/api/v1/credits/actions` endpoint today (spec Open Q #3 path b).
 * If/when the backend exposes these dynamically, replace these constants with a
 * cached `CreditsService.getActions()` fetch. Keep in sync with the PHP config.
 */
export const CREDIT_COSTS = {
  // Backend charges 2 (config/credits.php 'email_retrieval' => 2); this was
  // wrongly 4 and made the unlock-email modals overstate the cost.
  email_retrieval: 2,
  pipeline_run_base: 1,
  pipeline_per_lead_scheduled: 2,
  pipeline_manual_resume_premium: 5,
  daily_leads_enhanced_report: 4,
} as const;

/**
 * Total credits for a manual run-now, matching the backend exactly:
 * `pipeline_run_base + (pipeline_per_lead_scheduled × leads_per_day) + pipeline_manual_resume_premium`.
 */
export function manualRunCost(leadsPerDay: number): {
  base: number;
  perLead: number;
  perLeadTotal: number;
  premium: number;
  total: number;
} {
  const base = CREDIT_COSTS.pipeline_run_base;
  const perLead = CREDIT_COSTS.pipeline_per_lead_scheduled;
  const premium = CREDIT_COSTS.pipeline_manual_resume_premium;
  const perLeadTotal = perLead * leadsPerDay;
  return { base, perLead, perLeadTotal, premium, total: base + perLeadTotal + premium };
}
